export default "__VITE_ASSET__01ybBN1d__"